<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '../ui-utils.ts';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <tr :class="cn('border-b transition-colors hover:bg-slate-100/50 data-[state=selected]:bg-slate-100', props.class)">
    <slot />
  </tr>
</template>
